function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgBuild(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M8.899 8.977h6.737M8.899 5.688h6.737",
    stroke: props.fillSecondary
  }), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M3.962 12.7c0 .54.442.976.987.976h2.962A.982.982 0 008.9 12.7V1.975A.981.981 0 007.91 1H4.95a.981.981 0 00-.987.975v10.726zM1 9.776c0 .538.442.975.987.975h1.975V3.925H1.987A.981.981 0 001 4.9v4.876zM20.573 12.7a.982.982 0 01-.987.976h-2.962a.981.981 0 01-.988-.975V1.975c0-.539.443-.975.988-.975h2.962c.545 0 .987.436.987.975v10.726zM23.535 9.776a.982.982 0 01-.987.975h-1.975V3.925h1.975c.545 0 .987.437.987.975v4.876z",
    stroke: props.fillSecondary
  }));
}

export default SvgBuild;